<template>
    <TemplatesHome v-if="status == 'success'" :data="pageDate" />
</template>

<script setup>
    definePageMeta({
        pageTransition: usePageAltTransition()
    });

    const { data: home, status } = await useAsyncGql({
        operation: "home"
    });

    const pageDate = computed(() => home.value?.home);

    if (pageDate.value) {
        useBodyClass("home w-hero light");
        useSeoMeta(useSeoData(pageDate.value?.seo));
    } else {
        throw createError({ statusCode: 404, statusMessage: "Page Not Found" });
    }
</script>
